import React from "react";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Pricing from "../components/Pricing";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";

const Home = ({ theme, scrollTo }) => (
  <>
    <Hero scrollTo={scrollTo} />
    <Features theme={theme} />
    <Pricing theme={theme} />
    <FAQ theme={theme} />
    <Contact theme={theme} />
  </>
);

export default Home;